import script from "./TableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TableActions.vue?vue&type=script&setup=true&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=bf5421fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf5421fc"]])

export default __exports__